import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import type { LocationState } from "@/hooks";
import { ROUTES } from "@/router";
import { Button } from "@/ui";

interface RecoveryCodesProps {
  recoveryCodes: string[];
}
export const RecoveryCodes = ({ recoveryCodes }: RecoveryCodesProps) => {
  const [hasDownloadedCodes, setHasDownloadedCodes] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleDownload = () => {
    const fileContent = recoveryCodes.join("\n");

    const blob = new Blob([fileContent], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "recovery-codes.txt";
    anchor.click();
    URL.revokeObjectURL(url);
    setHasDownloadedCodes(true);
  };

  return (
    <>
      <div className="flex flex-col gap-y-2 text-center text-primary-950">
        <h1 className="text-2xl font-bold">Download your recovery codes</h1>
        <p>
          You can use these codes in case you lose access to your device. We
          recommend saving them in a secure space.
        </p>
      </div>
      <ul className="grid justify-items-center gap-y-2 rounded-xl bg-primary-50 p-4 font-medium text-primary-950">
        {recoveryCodes.map((recoveryCode) => {
          return <li key={recoveryCode}>{recoveryCode}</li>;
        })}
      </ul>
      <div className="flex gap-x-6">
        <Button
          className="mt-8 w-full font-semibold"
          onClick={handleDownload}
          variant="secondary"
        >
          Download
        </Button>
        <Button
          className="mt-8 w-full font-semibold"
          onClick={() => {
            const state = location.state as LocationState;
            const from = state?.from;

            const redirectTo = from
              ? `${from.pathname ?? ""}${from.search ?? ""}`
              : ROUTES.newIntake;

            void navigate(redirectTo, { replace: true });
          }}
          disabled={!hasDownloadedCodes}
        >
          Continue
        </Button>
      </div>
    </>
  );
};
